import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'breakAfterComma',
  standalone: true
})
/** Umožní dělení dlouhých názvů na více řádků */
export class BreakAfterCommaPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value)
      return '';
    
    // Add a zero-width space after each comma
    return value.replace(/,/g, ',\u200B');
  }
}
